<form nz-form [formGroup]="form" (ngSubmit)="submit()" role="form">
  <nz-tabset [nzAnimated]="false" class="tabs" (nzSelectChange)="switch($event)">
    <nz-tab [nzTitle]="'Login' | i18n">
      @if (error) {
        <nz-alert [nzType]="'error'" [nzMessage]="error" [nzShowIcon]="true" class="mb-lg" />
      }
      <nz-form-item>
        <nz-form-control nzErrorTip="Please enter email">
          <nz-input-group nzSize="large" nzPrefixIcon="user">
            <input nz-input formControlName="userName" placeholder="Enter email" />
          </nz-input-group>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-control nzErrorTip="Please enter password">
          <nz-input-group nzSize="large" nzPrefixIcon="lock">
            <input nz-input type="password" formControlName="password" placeholder="Enter password" />
          </nz-input-group>
        </nz-form-control>
      </nz-form-item>
    </nz-tab>
  </nz-tabset>
  <nz-form-item>
    <nz-col [nzSpan]="12">
      <!-- <label nz-checkbox formControlName="remember">{{ 'app.login.remember-me' | i18n }}</label> -->
    </nz-col>
    <nz-col [nzSpan]="12" class="text-right">
      <!-- <a class="forgot" routerLink="/passport/register">{{ 'app.login.forgot-password' | i18n }}</a> -->
    </nz-col>
  </nz-form-item>
  <nz-form-item>
    <button nz-button type="submit" nzType="primary" nzSize="large" [nzLoading]="loading" nzBlock>
      {{ 'app.login.login' | i18n }}
    </button>
  </nz-form-item>
</form>
<div class="other">
  <!-- <a class="register" routerLink="/passport/register">{{ 'app.login.signup' | i18n }}</a> -->
</div>
